import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import { createSelector } from 'reselect';
import { getIsAdmin, getVisibleOrderedFilteredWishes } from 'store/firebase/selectors';
import { getShowSidebar } from 'store/sidebar/selectors';
import Wishes from './Wishes';

const mapStateToProps = createSelector(
  getIsAdmin,
  getVisibleOrderedFilteredWishes,
  getShowSidebar,
  (isAdmin, wishes, showSidebar) => ({
    isAdmin,
    wishes,
    widthOffset: showSidebar ? 280 : 0
  })
);

export default compose(
  firebaseConnect([
    'wishes'
  ]),
  connect(mapStateToProps)
)(Wishes);



// WEBPACK FOOTER //
// ./src/components/Wishes/index.js